<template>
  <v-system-bar
    :height="(isRedslave && impersonateMode) || (isRedslave && isPreview) ? 60 : 30"
    class="d-block pa-0"
  >
    <info-bar-text v-if="isRedslave" color="red" :text="$t('readOnlyMode')" />
    <info-bar-impersonate v-if="impersonateMode" :impersonation-status="impersonationStatus" />
    <info-bar-text v-if="isPreview" :text="$t('quotePreview')" />
  </v-system-bar>
</template>

<script setup lang="ts">
import InfoBarImpersonate from '@/components/info-bar/InfoBarImpersonate.vue'
import InfoBarText from '@/components/info-bar/InfoBarText.vue'
import useAuthentication from '@/modules/authentication/useAuthentication'
import useSubsidiary from '@/modules/subsidiary/useSubsidiary'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

const { impersonationStatus } = storeToRefs(useSubsidiary())

const isRedslave = computed(() => useAuthentication().state.value.isRedslave)
const isPreview = computed(() => useAuthentication().state.value.isReadonly)
const impersonateMode = computed(() => useAuthentication().state.value.isImpersonateMode)
</script>
